import { createIcon } from '@chakra-ui/react/icon'

const ArrowLeftIcon = createIcon({
  displayName: 'ArrowLeftIcon',
  viewBox: '0 0 44 44',
  path: [
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15.5774 21.4106C15.252 21.736 15.252 22.2637 15.5774 22.5891L20.5774 27.5891C20.9028 27.9145 21.4305 27.9145 21.7559 27.5891C22.0814 27.2637 22.0814 26.736 21.7559 26.4106L18.1785 22.8332H27.8333C28.2936 22.8332 28.6667 22.4601 28.6667 21.9998C28.6667 21.5396 28.2936 21.1665 27.8333 21.1665L18.1785 21.1665L21.7559 17.5891C22.0814 17.2637 22.0814 16.736 21.7559 16.4106C21.4305 16.0851 20.9029 16.0851 20.5774 16.4106L15.5774 21.4106Z"
      fill="#0E0E0F"
    />,
  ],
  defaultProps: {
    width: '44px',
    height: '44px',
  },
})

export default ArrowLeftIcon
